import { projectClient } from '../../client/client';
import * as ext from './conversation-ext';

export const conversation = {
  create: projectClient('/messaging/conversation').post,
  message: projectClient('/messaging/conversation/{conversationId}/message').post,
  participant: projectClient('/messaging/conversation/{conversationId}/participant').post,
  removeParticipant: projectClient('/messaging/conversation/{conversationId}/participant').delete,
  getToken: projectClient('/messaging/conversation/token').get,
  ...ext,
};
